import {EyeIcon} from "@/components/shared";
import dynamic from "next/dynamic";
import React from "react";
import Loader from "../Loader";
const Chart = dynamic(() => import("react-apexcharts"), {ssr: false});
interface TotalAttendanceProps {
  isLoading: boolean;
  totalAttendance: any;
  totalAttChartOption: any;
  totalAttChartKey: number;
  totalAttSeries: any;
  openPopup: (title: popupParams) => void;
}
const TotalAttendanceWidget: React.FC<TotalAttendanceProps> = ({
  isLoading,
  totalAttendance,
  totalAttChartKey,
  totalAttChartOption,
  totalAttSeries,
  openPopup
}) => {
  const hasAttendanceData = totalAttSeries.some(
    (value: number) => Number(value) > 0
  );
  const attendanceChartSeries = hasAttendanceData ? totalAttSeries : [1];
  const attendanceChartOptions = hasAttendanceData
    ? totalAttChartOption
    : {
        ...totalAttChartOption,
        labels: ["No Data"],
        colors: ["#E5E7EB"],
        plotOptions: {
          ...totalAttChartOption.plotOptions,
          pie: {
            ...totalAttChartOption.plotOptions?.pie,
            donut: {
              ...totalAttChartOption.plotOptions?.pie?.donut,
              labels: {
                ...totalAttChartOption.plotOptions?.pie?.donut?.labels,
                total: {
                  ...totalAttChartOption.plotOptions?.pie?.donut?.labels?.total,
                  formatter: () => "0"
                },
                value: {
                  ...totalAttChartOption.plotOptions?.pie?.donut?.labels?.value,
                  formatter: () => "0"
                }
              }
            }
          }
        },
        tooltip: {
          enabled: false
        }
      };

  return (
    <>
      <div className="rounded-2xl border bg-neo-white ">
        <div className="p-2">
          <div className="flex items-center justify-between px-2">
            <h5 className="text-lg font-semibold">Total Attendance</h5>
            <h5
              className="cursor-pointer"
              title="View"
              onClick={() => openPopup({title: "Total Attendance"})}
            >
              <EyeIcon size={18} />
            </h5>
          </div>
          <div className="flex items-center justify-between px-2">
            {/* <p className="text-sm text-gray-500">
              Attendance summary of students in the fleet.
            </p> */}
          </div>
          <div
            className={`mt-5 rounded-full border-[#FFC7271A] bg-[#FFC7271A] ${isLoading ? "hidden" : "block"}`}
          >
            {/* <div className="justify-left flex">
              <img
                className="h-12 w-12 max-w-xs p-2"
                src="/icons/UserGroup.svg"
                alt="Trip"
              />
              <h5 className="pt-2 text-base font-semibold">
                Total Students{" "}
                <span className="ml-3 text-xl font-semibold">
                  {totalAttendance.total}
                </span>
              </h5>
            </div> */}
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="flex items-center justify-between gap-2 p-2">
              <Chart
                key={totalAttChartKey}
                options={attendanceChartOptions}
                series={attendanceChartSeries}
                type="donut"
                width="180"
                height="180"
              />
              <div className="flex flex-col gap-2 pt-5">
                <div className="">
                  <div className="justify-left flex">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100">
                      <svg
                        className="h-5 w-5 text-blue-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-7.364 7.364a1 1 0 01-1.414 0L3.293 9.293a1 1 0 011.414-1.414L8 11.172l6.293-6.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="pl-2">
                      <h5 className="text-base">Present</h5>
                      <h5 className="text-xl font-semibold">
                        {totalAttendance.present}
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="justify-left flex">
                    <div className="flex h-10 w-10 items-center justify-center rounded-full bg-orange-100">
                      <svg
                        className="h-5 w-5 text-orange-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="pl-2">
                      <h5 className="text-base">Absent</h5>
                      <h5 className="text-xl font-semibold">
                        {totalAttendance.absent}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TotalAttendanceWidget;
